import { useState, type FormEvent } from 'react';

import { Button } from '@/components/Button/Button';
import { Callout } from '@/components/Callout/Callout';
import { TextField } from '@/components/TextField/TextField';

import styles from './CreateApiKeyForm.module.css';

export interface CreateApiKeyFormProps {
  pending?: boolean;
  error?: string | null;
  onSubmit: (name: string) => void;
  onCancel: () => void;
}

export function CreateApiKeyForm({
  pending = false,
  error = null,
  onSubmit,
  onCancel,
}: CreateApiKeyFormProps) {
  const [name, setName] = useState('');
  const [attempted, setAttempted] = useState(false);
  const trimmed = name.trim();

  function submit(event: FormEvent) {
    event.preventDefault();
    setAttempted(true);
    if (trimmed) {
      onSubmit(trimmed);
    }
  }

  return (
    <form className={styles.form} onSubmit={submit} noValidate>
      {error ? <Callout tone="danger">{error}</Callout> : null}
      <TextField
        label="Name"
        name="key-name"
        autoComplete="off"
        autoFocus
        maxLength={100}
        placeholder="Production"
        hint="A label to tell your keys apart. Only you see it."
        error={attempted && !trimmed ? 'Give the key a name.' : undefined}
        value={name}
        onChange={(event) => setName(event.target.value)}
      />
      <div className={styles.actions}>
        <Button type="button" variant="ghost" onClick={onCancel} disabled={pending}>
          Cancel
        </Button>
        <Button type="submit" loading={pending}>
          Create key
        </Button>
      </div>
    </form>
  );
}
